<template>
    <div class="screenBox">
        <div class="containBox">
            <div class="Head-title">
                山东博物馆馆藏文物保存环境监测系统
            </div>
            <div class="C-right"></div>
            <div class="C-btns">
                <div class="btnNo" @click="showPage">进入馆内</div>
            </div>
            <div class="footer-bot"></div>
            <div class="C-left"></div>
            
            <div class="BoxCss">
                <modeHome v-if="page == 1"/>
            </div>

        </div>
        
        

        <div class="maxBox" ref="container">

        </div>
    </div>
</template>
<script>
import modeHome from './mode1.vue'
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import TWEEN from "@tweenjs/tween.js";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
let camera, scene, renderer, controls;
export default{
    components:{
        modeHome,
    },
    data(){
        return{
            page:1,
        }
    },
    mounted(){
        this.init()
    },
    methods:{
        init(){
            let dom = this.$refs.container
            var width = dom.clientWidth; //窗口宽度
            var height = dom.clientHeight; //窗口高度
            var k = width / height; //窗口宽高比

            renderer = new THREE.WebGLRenderer({ antialias:true, alpha: true, physicallyCorrectLights:true })
            renderer.setPixelRatio( window.devicePixelRatio )
            renderer.setSize(width, height)
            dom.appendChild( renderer.domElement )

            scene = new THREE.Scene()
            // // 创建一个纹理图片加载器加载图片
            var textureLoader = new THREE.CubeTextureLoader();
            // 加载背景图片
            var texture = textureLoader.load([
            'test3/px.png','test3/nx.png',
            'test3/py.png','test3/ny.png',
            'test3/pz.png','test3/nz.png',
            ]);
            // 纹理对象Texture赋值给场景对象的背景属性.background
            scene.background = texture
            //设置场景对象Scene的雾化属性.fog来模拟生活中雾化效果
            scene.fog = new THREE.Fog(0xffffff, 1, 1000);

            camera = new THREE.PerspectiveCamera( 60, k, 1, 2000 )
            camera.position.set(0, 0, 200)

            // 平行光1
            var directionalLight = new THREE.DirectionalLight(0xdddddd, 2);
            directionalLight.position.set(300, 100, 200);
            scene.add(directionalLight);

            // 平行光2
            var directionalLight2 = new THREE.DirectionalLight(0xdddddd, 2);
            directionalLight2.position.set(-300, 100, 200);
            scene.add(directionalLight2);

            //环境光1
            var ambient = new THREE.AmbientLight(0xffffff,0.5);
            scene.add(ambient);



            controls = new OrbitControls( camera, renderer.domElement );
            controls.maxPolarAngle = Math.PI * 0.495;
            controls.target.set( 0, 10, 0 );
            controls.minDistance = 40.0;
            controls.maxDistance = 1000.0;
            controls.update();

            window.addEventListener( 'resize', onWindowResize );
            function onWindowResize() {
                camera.aspect = window.innerWidth / window.innerHeight;
                camera.updateProjectionMatrix();
                renderer.setSize(window.innerWidth, window.innerHeight);
            }

            var loader = new GLTFLoader(); //创建一个1GLTF加载器
            loader.load('mode.glb', (gltf)=> {
                let group = gltf.scene
                scene.add(group);
                // 包围盒计算模型对象的大小和位置
                var box3 = new THREE.Box3();
                box3.expandByObject(gltf.scene); // 计算模型包围盒
                var size = new THREE.Vector3();
                box3.getSize(size); // 计算包围盒尺寸
                var center = new THREE.Vector3();
                box3.getCenter(center); // 计算一个层级模型对应包围盒的几何体中心坐标
                // 计算包围盒的最大边长
                function maxSize(vec3) {
                    var max;
                    if (vec3.x > vec3.y) {
                        max = vec3.x
                    } else {
                        max = vec3.y
                    }
                    if (max > vec3.z) {} else {
                        max = vec3.z
                    }
                    return max;
                }

                var max = maxSize(size); //包围盒长宽高中最大的一个值，用来表征模型的尺寸
                // 1.控制渲染范围，但是不要忘记相机位于模型包围盒之外
                camera.position.copy(center.clone().addScalar(max * 0.5));
                // 2. 居中渲染：设置相机目标观察点，指向包围盒几何中心
                camera.lookAt(center);
                // 3.注意near和far尺寸控制
                camera.near = max*0.1;//最好和相机位置或者说包围盒关联，别设置0.1 1之类看似小的值
                camera.far = max * 3;//根据相机位置和包围大小设置，把包围盒包含进去即可，宁可把偏大，不可偏小
                camera.updateProjectionMatrix();//渲染范围改变，注意更新投影矩阵
            })
            // ground
            function Ground() {
                const gt = new THREE.TextureLoader().load( "bg/ground1.jpg" );
                const gg = new THREE.PlaneGeometry( 3000, 3000 );
                const gm = new THREE.MeshLambertMaterial( { color: 0xd0d7e1, map: gt } );
                const ground = new THREE.Mesh( gg, gm );
                ground.rotation.x = - Math.PI / 2;
                ground.material.map.repeat.set( 60, 60 );
                ground.material.map.wrapS = THREE.RepeatWrapping;
                ground.material.map.wrapT = THREE.RepeatWrapping;
                ground.receiveShadow = true;
                scene.add( ground );
            }
            Ground()
            function animate() {
                requestAnimationFrame( animate );
                renderer.render( scene, camera );
            }
            animate()
        },
        showPage(){
            window.open(window.g.qjView,'_blank')
        }
    }
}
</script>
<style lang="scss" scoped>
.screenBox{
    width: 100%;
    height: 100vh;
    position: relative;
}
.containBox{
    width: 100%;
    height: 100%;
    pointer-events:none;
    position: absolute;
    box-shadow: 0px 0px 200px 200px #080e13d5 inset;
    top:0;
    left:0;
    .BoxCss{
        width:100%;
        height:100%;
        position: relative;
        .floorBtns{
            position: absolute;
            top:80px;
            right:80px;
            width:330px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .floorBtn{
                width: 100px;
                text-align: center;
                line-height: 40px;
                color: white;
                pointer-events: all;
                cursor: pointer;
                height: 40px;
                font-size: 14px;
                background-image: url('../../assets/img/Pobtn.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
            }
            .floorBtnActive{
                width: 100px;
                text-align: center;
                line-height: 40px;
                color: white;
                pointer-events: all;
                cursor: pointer;
                height: 40px;
                font-size: 14px;
                background-image: url('../../assets/img/PobtnActive.png');
                background-size: 100% 100%;
                background-repeat: no-repeat; 
            }
        } 
    }

    .Head-title{
        position: absolute;
        top:0px;
        left: 0px;
        width: 100%;
        height: 100px;
        background-image: url('../../assets/img/head.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 70px;
    }
    .footer-bot{
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        height: 100px;
        background-image: url('../../assets/img/bottom.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
    .C-left{
        position: absolute;
        width: 40px;
        height: 100%;
        left: 0px;
        top: 0px;
        background-image: url('../../assets/img/C-left.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
    .C-right{
        position: absolute;
        width: 40px;
        height: 100%;
        right: 0px;
        top: 0px;
        background-image: url('../../assets/img/C-right.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
    .C-btns{
        position: absolute;
        bottom:300px;
        left: calc(50% - 30px);
        margin:auto;
        color: white;
        width: 130px;
        display: flex;
        justify-content: space-between;
        .btnNo{
            display: flex;
            font-size: 14px;
            justify-content: center;
            align-items: center;
            width: 130px;
            cursor: pointer;
            pointer-events: all;
            height: 50px;
            background-image: url('../../assets/img/btnNo.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
        .btnActive{
            background-image: url('../../assets/img/btn.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
    }
}
.floorBox{
    position: relative;
    width: 100%;
    height: 100%;
    .msgBox{
        pointer-events: all;
        position: absolute;
        top:100px;
        box-sizing: border-box;
        left: 50px;
        width: 400px;
        border: 1px solid #198DE5;
        .title{
            width: 100%;
            height: 40px;
            line-height: 40px;
            padding-left: 20px;
            box-sizing: border-box;
            color: white;
            background-image: url('../../assets/img/labelBg.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            position: relative;
            .close{
                position: absolute;
                top:0px;
                right: 5px;
                color: #d2d2d2;
                font-size: 16px;
                cursor: pointer;
            }
        }
        .boxBottom{
            width: 100%;
            padding: 20px;
            box-sizing: border-box;
            min-height: 300px;
            background-color: rgba($color: #198DE5, $alpha: 0.5);
            color: #FFFFFF;
            font-size: 14px;
            .BB-top{
                width: 100%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                .BT-item{
                    text-align: center;
                    img{
                        margin: 10px  0px;    
                    }
                }
            }
        }
    }
    .label{
        pointer-events: all;
        position: absolute;
        top:0;
        left:0;
        display: none;
        width: 180px;
        height: 40px;
        padding-left:50px;
        box-sizing: border-box;
        line-height: 40px;
        color: white;
        font-size: 16px;
        background-image: url('../../assets/img/ztLabel.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
    }
}
.roomBox{
    width: 100%;
    height: 100%;
    position: relative;
    .RoomLabel{
        pointer-events: all;
        position: absolute;
        top:0;
        left:0;
        display: none;
        width: 20px;
        height: 20px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .zgLabel{
        background-image: url('../../assets/img/ztLabel.png');
        background-repeat: no-repeat;
        background-size: cover;
    }
    .wwLabel{
        background-image: url('../../assets/img/wwLabel.png');
        background-repeat: no-repeat;
        background-size: cover;
    }
    .roomBtns{
        position: absolute;
        top:35%;
        right:80px;
        width:100px;
        height: 140px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        .roomBtn{
            width: 100%;
            text-align: center;
            line-height: 40px;
            color: white;
            pointer-events: all;
            cursor: pointer;
            height: 40px;
            font-size: 14px;
            background-image: url('../../assets/img/Pobtn.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }
        .roomBtnActive{
            width: 100px;
            text-align: center;
            line-height: 40px;
            color: white;
            pointer-events: all;
            cursor: pointer;
            height: 40px;
            font-size: 14px;
            background-image: url('../../assets/img/PobtnActive.png');
            background-size: 100% 100%;
            background-repeat: no-repeat; 
        }
    }
    .zgmsgBox{
        pointer-events: all;
        position: absolute;
        top:100px;
        box-sizing: border-box;
        left: 50px;
        width: 400px;
        border: 1px solid #198DE5;
        .title{
            width: 100%;
            height: 40px;
            line-height: 40px;
            padding-left: 20px;
            box-sizing: border-box;
            color: white;
            background-image: url('../../assets/img/labelBg.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            position: relative;
            .close{
                position: absolute;
                top:0px;
                right: 5px;
                color: #d2d2d2;
                font-size: 16px;
                cursor: pointer;
            }
        }
        .boxBottom{
            width: 100%;
            padding: 20px;
            box-sizing: border-box;
            min-height: 300px;
            background-color: rgba($color: #198DE5, $alpha: 0.5);
            color: #FFFFFF;
            font-size: 14px;
            .tips{
                color: #198DE5;
                font-size: 20px;
                margin-right: 10px;
            }
            .wtips{
                color: red;
                margin-right: 10px;
                font-size: 20px;
            }
            .lineBox{
                display: flex;
                justify-content:space-around;
                align-items: center;
                margin-top: 20px;
                width: 100%;
                .Item{
                    width: 100px;
                    height: 30px;
                    text-align: center;
                    line-height: 30px;
                    background: rgba(11,63,112,0.5);
                    border: 1px solid #2087E8;
                    color:#2087E8 ;
                }
                .wItem{
                    text-align: center;
                    width: 100px;
                    line-height: 30px;
                    height: 30px;
                    background: rgba(115,8,8,0.5);
                    border: 1px solid #FF4D4D;
                    color:#FF4D4D;
                }
            }
            .chart{
                width: 100%;
                height: 200px;
            }
        }
    }
    .wwmsgBox{
        pointer-events: all;
        position: absolute;
        top:100px;
        box-sizing: border-box;
        left: 50px;
        width: 400px;
        border: 1px solid #7E4901;
        .title{
            width: 100%;
            height: 40px;
            line-height: 40px;
            padding-left: 20px;
            box-sizing: border-box;
            color: white;
            background-image: url('../../assets/img/wwtitle.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            position: relative;
            .close{
                position: absolute;
                top:0px;
                right: 5px;
                color: #d2d2d2;
                font-size: 16px;
                cursor: pointer;
            }
        }
        .boxBottom{
            width: 100%;
            padding: 20px;
            box-sizing: border-box;
            min-height: 300px;
            background-color: rgba($color: #7E4901, $alpha: 0.3);
            color: #FFFFFF;
            font-size: 14px;
            .oper{
                display:flex;
                justify-content:flex-end;
            }
            .wwMsg{
                margin-top:20px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                img{
                    width:100px;
                    height:100px;
                    object-fit:contain;
                }
                .msgCss{
                    width:calc(100% - 120px);
                    line-height:24px;
                }
            }
            .chartTitle{
                text-align:center;
                margin-top:20px;
                font-size:16px;
                font-weight:bold;
            }
            .chart{
                width:100%;
                height:200px;
            }
        }
    }
}

.maxBox{
    width: 100%;
    height: 100%;
}

</style>